export default function Marquee() {
  const words = [
    "SEM GLÚTEN",
    "SEM LACTOSE",
    "COM COLÁGENO HIDROLISADO",
    "DOÇURA QUE TE MOVE",
    "THE QUICK BROWNIE",
  ];
  const items = [...words, ...words, ...words];

  return (
    <section aria-hidden="true" className="border-y border-black overflow-hidden">
      <div className="py-5 md:py-6">
        <div className="marquee font-display text-2xl md:text-4xl uppercase tracking-tight">
          {items.map((w, i) => (
            <span key={i} className="flex items-center gap-10">
              {w}
              <span className="w-2 h-2 bg-black inline-block rounded-full" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
